import Cookies from 'js-cookie'
import $ from 'jquery'
import {getParams} from './urlQuery'

/**
 * @returns ept | th
 */
export function getSystem(){
	var systemFlag=$("#systemFlag").val()
	return systemFlag||'ept'
}

/**
 * @returns TH | RU | US
 */
export function getSite(){
	var site=getParams().siteName
	if(site)return site.toUpperCase()
	site=$("#siteName").val()
	if(site)return site
	site=Cookies.get("site")
	if(site)return site
	var sys=getSystem()
	if(sys=='ept'){
		return 'US'
	}
	if(sys=='th'){
		return 'TH'
	}
	if(sys=='EJSHOP'){
		return 'XTL'
	}
	console.warn("无法获取站点")
}

export const countryNames = {
	XTL: "新通路",
	US: "EN station",
	TH: "Thailand station",
	RU: "Russian station",
	ES: "Spain station",
	ID:"Indonesia station"
}

export const siteMap={
	th:["TH"],
	ept:["US","RU","ES"],
	EJSHOP:["XTL"],
	id:["ID"]
}